module.exports = __webpack_public_path__ + "img/bancontact-mister-cash.1da87ce5.png";